import i18n from "../i18n";
import { defineRule, configure } from "vee-validate";
import { required, email, numeric } from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import { setLocale } from "@vee-validate/i18n";

const GlobalValudators = () => {
  defineRule("required", required);
  defineRule("email", email);
  defineRule("numeric", numeric);
  defineRule("confirmed", (value: string, [target]: Array<string>) => {
    if (value === target) {
      return true;
    }

    return false;
  });

  defineRule("birthdate", (value: string) => {
    const reg = /^(19[0-9][0-9]|20\d{2})\/(0[0-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1])$/;
    if (value.match(reg)) return true;
    return false;
  });

  defineRule("rrn1", (value: string) => {
    const reg = /([0-9]){6}/g;
    if (value.match(reg)) return true;
    return false;
  });

  defineRule("rrn2", (value: string) => {
    const reg = /([0-9]){7}/g;
    if (value.match(reg)) return true;
    return false;
  });
  defineRule("password", (value: string) => {
    //const reg = /(?=.*[a-zA-Z])(?=.*[!@#$%^&+=])([^\s]){8,20}$/g;
    const reg = /(?=.*[a-zA-Z])([^\s]){6,20}$/g;
    if (value.match(reg)) return true;
    return false;
  });
  configure({
    generateMessage: localize(messages),
  });
  defineRule("emailName", (value: string) => {
    // eslint-disable-next-line no-useless-escape
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))/;
    return value.match(reg) ? true : false;
  });

  defineRule("emailProvider", (value: string) => {
    // eslint-disable-next-line no-useless-escape
    const reg = /^((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return value.match(reg) ? true : false;
  });

  const locale = i18n.global.locale;
  if (locale && locale?.value.length > 0) {
    setLocale(locale.value);
  }
};

const messages = {
  en: {
    messages: {
      required: "*",
      email: "ex) abc@aaa.com",
      password: "At least 6 digits, alphabets and numbers",
      confirmed: "Password and password confirmation mismatch",
      birthdate: "YYYY/MM/DD",
    },
  },
  ko: {
    messages: {
      required: "입력 값이 비었습니다.",
      email: "예) abc@aaa.com",
      //password: '8자리이상, 문자, 숫자, !@#$%^&+= 중 1개 포함',
      password: "6자리 이상 문자, 숫자를 입력해 주세요",
      confirmed: "비밀번호와 비밀번호확인 불일치",
      birthdate: "YYYY/MM/DD",
    },
  },
  ja: {
    messages: {
      required: "*",
      email: "例) abc@aaa.com",
      password: "6桁以上、文字、数字",
      confirmed: "パスワードとパスワードの確認の不一致",
      birthdate: "YYYY/MM/DD",
    },
  },
  uz: {
    messages: {
      _default: "{field} haqiqiy emas",
      required: "{field} maydoni majburiy",
      email: "ex) abc@aaa.com",
      password: "6 yoki undan ortiq harf, raqam",
      confirmed: "Parol va parolni tasdiqlash qiymatlari o'zaro bir-biriga mos emas.",
      birthdate: "YYYY/MM/DD",
    },
  },
  ru: {
    messages: {
      _default: "Это поле необходимо заполнить.",
      required: "Это поле необходимо заполнить.",
      email: "ex) abc@aaa.com",
      password: "Пожалуйста, введите не менее 6 букв и цифр",
      confirmed: "Несовпадение пароля и подтверждения пароля",
      birthdate: "YYYY/MM/DD",
    },
  },
};

export default GlobalValudators;
